import { Outlet } from 'react-router-dom';
import { AdminSidebar, HomeIcon, BuildingIcon, ChartIcon, SettingsIcon, UsersIcon } from '../navigation/AdminSidebar';
import { useAuth } from '../../contexts/AuthContext';

export function SaaSLayout(): React.ReactElement {
  const { state } = useAuth();

  const sections = [
    {
      title: 'Overview',
      items: [
        { label: 'Dashboard', to: '/saas/dashboard', icon: <HomeIcon /> },
        { label: 'Analytics', to: '/saas/analytics', icon: <ChartIcon /> },
      ],
    },
    {
      title: 'Management',
      items: [
        { label: 'Tenants', to: '/saas/tenants', icon: <BuildingIcon /> },
        { label: 'Users', to: '/saas/users', icon: <UsersIcon /> },
      ],
    },
    {
      title: 'Settings',
      items: [
        { label: 'Platform Config', to: '/saas/config', icon: <SettingsIcon /> },
      ],
    },
  ];

  return (
    <div className="flex h-screen bg-background">
      <AdminSidebar
        title="CasinoSaaS"
        sections={sections}
        user={
          state.user
            ? {
                name: state.user.display_name || state.user.username,
                role: state.user.role,
              }
            : undefined
        }
      />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
